import auth from "../../auth";
export default {
  data() {
    return {
      isClient: false,
    };
  },
  created() {
    this.isClient = auth.getUser().isClient;
  },
  computed: {
    blockWidth() {
      return this.isClient;
    },
    disabled() {
      return this.isClient;
    },
    allowVisible() {
      return this.isClient;
    },
    heightTable() {
      return this.isClient;
    },
  },
};
